const BASE = 'https://api.tomtom.com/search/2';

const API_KEY =
  import.meta?.env?.VITE_TOMTOM_API_KEY ||
  process.env.VITE_TOMTOM_API_KEY ||
  '';

if (!API_KEY) {
  // Don’t throw; let UI handle gracefully
  // eslint-disable-next-line no-console
  console.warn('[TomTom] Missing API key. Set VITE_TOMTOM_API_KEY');
}

// Build query params helper
function qp(params = {}) {
  const p = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === '') return;
    p.set(k, String(v));
  });
  return p.toString();
}

/**
 * Fuzzy Search (typeahead) – good for autosuggest
 * https://developer.tomtom.com/search-api/documentation/search-service/fuzzy-search
 */
export async function tomtomTypeahead({
  query,
  limit = 5,
  language = import.meta.env.VITE_TOMTOM_LANGUAGE || 'en-US',
  countrySet = import.meta.env.VITE_TOMTOM_COUNTRYSET || 'US,GB',
  lat,
  lon,
  signal,
}) {
  if (!query || query.length < 2) return { results: [] };

  const url = `${BASE}/search/${encodeURIComponent(query)}.json?${qp({
    key: API_KEY,
    typeahead: true,
    limit,
    language,
    countrySet,
    lat,
    lon,
  })}`;

  // eslint-disable-next-line no-console
  console.debug('[TomTom] typeahead →', url);

  const res = await fetch(url, { signal });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`TomTom typeahead failed: ${res.status} ${text}`);
  }
  return res.json();
}

/**
 * Place Details by entityId
 * https://developer.tomtom.com/search-api/documentation/search-service/place-by-id
 */
export async function tomtomPlaceById(entityId, { signal } = {}) {
  if (!entityId) return null;

  const url = `${BASE}/place.json?${qp({
    key: API_KEY,
    entityId,
  })}`;

  // eslint-disable-next-line no-console
  console.debug('[TomTom] placeById →', url);

  const res = await fetch(url, { signal });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`TomTom placeById failed: ${res.status} ${text}`);
  }
  return res.json();
}

/** Normalize TomTom result → a predictable shape */
export function normalizeSuggestion(item = {}) {
  const addr = item.address || {};
  return {
    entityId: item.id || item.entityId || null,
    type: item.type || null,
    label: addr.freeformAddress || item.poi?.name || item.name || '',
    position: item.position || item.viewport?.topLeftPoint || null,
    address: {
      freeform: addr.freeformAddress || '',
      streetNumber: addr.streetNumber || '',
      streetName: addr.streetName || '',
      municipality: addr.municipality || '',
      countrySubdivision: addr.countrySubdivision || '',
      postalCode: addr.postalCode || '',
      countryCode: addr.countryCode || '',
      country: addr.country || '',
    },
    raw: item,
  };
}
